import { createSelector } from '@ngrx/store';
import { selectIndustriesMap, selectJobseekerStoreState } from '../jobseeker-profile/selectors';
import { selectHeadIndustries, selectChildIndustries } from '../jobseeker-industry/selectors';

export const selectIndustryPickerState = createSelector(
    selectJobseekerStoreState,
    s => s.industryPicker
);

export const selectSelectedIndustryIds = createSelector(
  selectIndustryPickerState,
    s => s.selectedIndustryIds
)

export const selectMaxIndustriesReached = createSelector(
  selectSelectedIndustryIds,
    s => s.length >= 10
);

export const selectSelectedIndustries = createSelector(
  selectSelectedIndustryIds,
  selectIndustriesMap,
    (s, c) => s.map(cc => c[cc])
);

export const selectDisplaySelectedIndustriesTags = createSelector(
  selectSelectedIndustries,
  s => s.concat().sort((a, b) => +a.code - +b.code)
);


export const selectHeadIndustriesExpandedMap = createSelector(
    selectHeadIndustries,
    selectIndustryPickerState,
    (headIndustries, uiState) => {
      const result: { [index: string]: boolean } = {};
  
      headIndustries.forEach((c) => {
        result[c.id] = false;
      });
  
      uiState.expandedIndustryIds.forEach((c) => {
        result[c] = true;
      });
  
      return result;
    }
  );
  
  export const selectIndustriesSelectedMap = createSelector(
    selectIndustryPickerState,
    selectChildIndustries,
    (f, o) => {
      const result = {};
      o.forEach((c) => (result[c.id] = false));
      f.selectedIndustryIds.forEach((c) => (result[c] = true));
      return result;
    }
  );

export const selectQuery = createSelector(
    selectIndustryPickerState,
    s => s.query
);

export const selectDisplayHeadIndustries = createSelector(
  selectQuery,
  selectHeadIndustries,
  selectChildIndustries,
  (query, headIndustries, childIndustries) => {

      const matchedHeads = headIndustries.filter(c => checkQuery(c.name, query));
      const matchedHeadIdSet = new Set(matchedHeads.map(c => c.id));
      
      const remainingMatchingChildren = childIndustries.filter(c => checkQuery(c.name, query) && !matchedHeadIdSet.has(c.parentId));

      const remainingMatchingChildrenHeadIdSet = new Set(remainingMatchingChildren.map(c => c.parentId));
      const remainingMatchingChildrenIdSet = new Set(remainingMatchingChildren.map(c => c.id));

      const remainingMatchigHeads = headIndustries.filter(c => remainingMatchingChildrenHeadIdSet.has(c.id)).map(c => {
          const result = Object.assign({}, c, { childIndustryIds: c.childIndustryIds.filter(cc => remainingMatchingChildrenIdSet.has(cc)) });

          return result;
      });

      return matchedHeads.concat(remainingMatchigHeads).sort((a, b) => a.name > b.name ? 1 : (a.name < b.name ? -1 : 0));
  }
);

export const selectDisplayHeadIndustriesSorted = createSelector(
  selectDisplayHeadIndustries,
  selectIndustriesMap,
  (selectHead, selectAllIndustriesMap) => {
    const selectedHead = selectHead.map((v) => {
      return {
        ...v,
        childIndustryIds: v.childIndustryIds
          .map((vv) => selectAllIndustriesMap[vv])
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((industries) => industries.id),
      };
    });
    
    return selectedHead;
  }
);

// export const selectDisplayHeadIndustries = createSelector(
//   selectIndustries,
//    (industries) => {
//     const industryMap = new Map<string, { id: string; name: string; code: string; index: number; parentId: string | null; childIndustryIds?: string[] }>();

//     industries.forEach(industry => {
//       if (industry.parentId === null) {
//         industryMap.set(industry.id, { ...industry, childIndustryIds: [] });
//       } else {
//         industryMap.set(industry.id, { ...industry });
//       }
//     });
  
//     industries.forEach(industry => {
//       if (industry.parentId) {
//         const parent = industryMap.get(industry.parentId);
//         parent?.childIndustryIds?.push(industry.id);
//       }
//     });
  
//     return Array.from(industryMap.values()).filter(industry => industry.parentId === null);
// });


function checkQuery(text: string, query: string){
    return query === null || query ==='' || query.length < 2 || text.includes(query);
}


export const selectAtLeastOneIndustrySelected = createSelector(
    selectSelectedIndustryIds,
    s => s.length > 0
);